// Define an enum for valid HTTP status codes
export enum HttpStatus {
  OK = 200,
  Created = 201,
  PartialContent = 206,
  BadRequest = 400,
  Unauthorized = 401,
  PaymentRequired = 402,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  TooManyRequest = 429,
  InternalServerError = 500,
  Conflict = 409,
  ServiceUnavailable = 503,
}

// Update the ResponseFormatModel class to use the HttpStatus enum
export class ResponseFormatModel {
  static invalid400Response = new ResponseFormatModel(
    HttpStatus.BadRequest,
    "Invalid Request: Please check the request and try again",
  );
  static loginFailed403Response = new ResponseFormatModel(
    HttpStatus.Forbidden,
    "Invalid Login. Login Again",
  );
  static loginFailedNoEmailId403Response = new ResponseFormatModel(
    HttpStatus.Forbidden,
    "Aw, Snap Invalid Login. No User with given email id exists",
  );
  static loginFailed404Response = new ResponseFormatModel(
    HttpStatus.NotFound,
    "Aw, Snap Invalid Login, Please check your credentials and login again",
  );
  static accessDenied403Response = new ResponseFormatModel(
    HttpStatus.Forbidden,
    "Aw, Snap! You don't have access to this resource",
  );
  static success200Response = new ResponseFormatModel(HttpStatus.OK, "Success");
  static successReload201Response = new ResponseFormatModel(
    HttpStatus.Created,
    "Success",
  );
  static serverSideError500Response = new ResponseFormatModel(
    HttpStatus.InternalServerError,
    "It's not you it's us. Please try again later",
  );
  static noFileError500Response = new ResponseFormatModel(
    HttpStatus.InternalServerError,
    "No File Found. Please try again",
  );
  static fileUploadError500Response = new ResponseFormatModel(
    HttpStatus.InternalServerError,
    "File upload error. Please try again",
  );
  static fileUploadSuccess200Response = new ResponseFormatModel(
    HttpStatus.OK,
    "File uploaded",
  );
  static apiNotAllowedResponse = new ResponseFormatModel(
    HttpStatus.MethodNotAllowed,
    "This API call not allowed",
  );
  static serviceUnavailableResponse = new ResponseFormatModel(
    HttpStatus.ServiceUnavailable,
    "Service is currently unavailable. Please try again later",
  );
  status: HttpStatus;
  message: string;
  data?: any;

  constructor(status: HttpStatus, message: string, data?: any) {
    if (!(status in HttpStatus)) {
      throw new Error("Invalid HTTP status code");
    }
    this.status = status;
    this.message = message;
    if (data) {
      this.data = ResponseFormatModel.flattenData(data);
    }
  }

  static flattenData(data: any): any {
    while (data && typeof data === "object" && "data" in data) {
      data = data.data;
    }
    return data;
  }

  static fromStatusCode(
    statusCode: number,
    message: string,
    data?: any,
  ): ResponseFormatModel {
    let status: HttpStatus;
    if (statusCode in HttpStatus) {
      status = statusCode as HttpStatus;
    } else if (statusCode === 401) {
      status = HttpStatus.Unauthorized;
    } else if (statusCode === 404) {
      status = HttpStatus.NotFound;
    } else if (statusCode >= 500) {
      status = HttpStatus.InternalServerError;
    } else {
      status = HttpStatus.BadRequest;
    }
    return new ResponseFormatModel(status, message, data);
  }
}
